import { render, staticRenderFns } from "./CoreWysiwyg.vue?vue&type=template&id=6aa7e191&scoped=true&"
import script from "./CoreWysiwyg.vue?vue&type=script&lang=js&"
export * from "./CoreWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./CoreWysiwyg.vue?vue&type=style&index=0&id=6aa7e191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7e191",
  null
  
)

export default component.exports